import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/inviteRecord/page', data, {
    trim: true
  })
}
export function exportExcel (data) {
  return request.post('/business/inviteRecord/exportExcel', data, {
    trim: true,
    download: true
  })
}
